import View from './view'
import {combineStates, reducer} from "../../support/join_contexts_HOC";
import {component_reducer, dispatchToProps, initState} from "./local_state/reducer";
import {JoinedTypePropsType, OwnPropsType} from "./index.types";
import {EventPropsType, InputPropsType} from "./view.types";
import Network from "../../support/network";
import {
    getFilmsImdbFilmaRequest,
} from "../../support/network/requests/google_search";
import {GetFilmIdResultType, UpdateMovieType} from "./local_state/reducer.types";
import {postFilmsAutocomplete} from "../../support/network/requests/films";
import {FilmType} from "../../models/film";
import {postPendingFilm} from "../../support/network/requests/pending_films";
import * as FilmRequest from "../../support/network/requests/films";

const enLiterals = ['eng']
const esLiterals = ['spa']

async function uploadList(listStr: string) {
    const hhh = /[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\n/g
    let out: string[] = []
    const matches = (listStr as string).matchAll(hhh);
    for (const match of matches) {
        out = [...out, match[0]]
        await processRow(match[0])
    }
}

function processRow(rowStr: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const audioRegExp = /Stream #\d:\d\(?(?<tag>[^\(\)\:]*)\)?: Audio.*(\n.*Metadata:.*(\n.*title.*:(?<title>.*))?(\n.*LANGUAGE.*:(?<lang>.*))?)?/g
        const subsRegExp = /Stream #\d:\d\(?(?<tag>[^\(\)\:]*)\)?: Subtitle.*(\n.*Metadata:.*(\n.*title.*:(?<title>.*))?(\n.*LANGUAGE.*:(?<lang>.*))?)?/g

        const ddd = rowStr.split('\t')
        // const filename = `${ddd[3]}/${ddd[1]}.${ddd[4]}`
        const langs: string[] = []
        const subs: string[] = ddd[6] ? ddd[6].split(',') : []
        const info = ddd[8]
        const audiosMatch = info.matchAll(audioRegExp);
        let audioCount = 0
        for (const a of audiosMatch) {
            audioCount = audioCount + 1
            let l = (a?.groups?.lang?.trim() === 'und' ? undefined : a?.groups?.lang?.trim()) || (a?.groups?.tag?.trim() === 'und' ? undefined : a?.groups?.tag?.trim()) || a?.groups?.title?.trim()
            enLiterals.forEach(it => l = l?.replace(it, 'en'))
            esLiterals.forEach(it => l = l?.replace(it, 'es'))
            if (l && !langs.includes(l)) {
                langs.push(l)
            }
        }
        const subsMatch = info.matchAll(subsRegExp);
        let subsCount = 0
        for (const s of subsMatch) {
            subsCount = subsCount + 1
            let l = (s?.groups?.lang?.trim() === 'und' ? undefined : s?.groups?.lang?.trim()) || (s?.groups?.tag?.trim() === 'und' ? undefined : s?.groups?.tag?.trim()) || s?.groups?.title?.trim()
            enLiterals.forEach(it => l = l?.replace(it, 'en'))
            esLiterals.forEach(it => l = l?.replace(it, 'es'))
            if (l && !subs.includes(l)) {
                subs.push(l)
            }
        }

        console.log(ddd)

        Network.instance.netClient.executeRequest(postPendingFilm({
            title: ddd[0],
            filename: ddd[1],
            year: ddd[2],
            folder: ddd[3],
            extension: ddd[4],
            size_mb: ddd[5] ? parseInt(ddd[5]) : undefined,
            md5: ddd[7],
            file_data: ddd[8],
            langs: langs.length > 0 ? langs.join(',') : audioCount.toString(),
            subs: subs.length > 0 ? subs.join(',') : subsCount.toString(),
        }, res => resolve()))
    })
}

export const mapProps = (ownProps: OwnPropsType & JoinedTypePropsType): InputPropsType => ({
    processResult: ownProps.reducer.getFilmIdResult,
    currentRow: ownProps.reducer.currentRow,
    getFilmIdResult: ownProps.reducer.getFilmIdResult
})

export const mapEvents = (ownProps: OwnPropsType & JoinedTypePropsType): EventPropsType => ({
    setList: async (listStr: string) => {
        // ownProps.reducer.setList(listStr)
        await uploadList(listStr)
    },
    processRow: () => {
        const onSuccess = (res: GetFilmIdResultType) => {
            console.log('onSuccess')
            console.log(res)
            ownProps.reducer.setGetFilmIdResult(res)
        }
        const onFailure =(error: any) => {
            if (error.status === 429) {
                alert('See you tomorrow. Don\'t forget to download the results')
            }
        }
        const film = ownProps.reducer.currentRow
        // if (ownProps.reducer.currentRow[8] && !ownProps.reducer.currentRow[7]) {
        //     console.log('imdb search')
        //     Network.instance.netClient.executeRequest(getFilmsImdbRequest(`${film.name} ${film.year}`, onSuccess, onFailure))
        // } else if (ownProps.reducer.currentRow[7] && !ownProps.reducer.currentRow[8]) {
        //     console.log('filmaffinity search')
        //     Network.instance.netClient.executeRequest(getFilmsFilmaRequest(`${film.name} ${film.year}`, onSuccess, onFailure))
        // }
        console.log('completr search')
        Network.instance.netClient.executeRequest(getFilmsImdbFilmaRequest(`${film.name} ${film.year || ''}`.trim(), onSuccess, onFailure))
    },
    downloadList: (forcedData?: string) => {
        const dataBlob = new Blob([forcedData || ownProps.reducer.list.join('\n')], { type: 'text/plain' })
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(dataBlob);
        // link.download = `list_${ownProps.reducer.currentIndex}.csv`;
        link.download = `list_${ownProps.reducer.list.length}.csv`;
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(link.href);
        }, 200);
    },
    uploadFilm: async (film: UpdateMovieType) => {
        new Promise<void>((resolve, reject) => {
            const filledFilm: FilmType = {
                file_name: film.fileName,
                folder: film.folder,
                format: film.ext,
                size: film.size,
                checksum: film.md5,
                imdb_id: film.imdbResult?.id || '',
                filmaffinity_id: film.filmaffinityResult?.id || '',
                languages: film.audio && film.audio?.length > 0 ? film.audio?.split(',') : undefined,
                subtitles: film.subs && film.subs?.length > 0 ? film.subs?.split(',') : undefined
            }
            console.log('filledFilm')
            console.log(filledFilm)
            Network.instance.netClient.executeRequest(postFilmsAutocomplete([filledFilm], (res) => {
                console.log(res)
                ownProps.reducer.deleteCurrent()
                resolve()
            }, (error) => {
                console.log(error)
                // ownProps.reducer.nextRow()
                resolve()
            }))
        })
    },
    skip: () => {
        // ownProps.reducer.nextRow()

        Network.instance.netClient.executeRequest(FilmRequest.getNextFolderAvailable((res) => {
            console.log(res)
        }, (error) => {
            console.log(error)
        }))
    },
})

export default combineStates<JoinedTypePropsType, OwnPropsType, InputPropsType, EventPropsType>(View, mapProps, mapEvents, [
    reducer.createComponent('reducer', component_reducer, initState, dispatchToProps)
])
